var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-number-wrapper"},[_c('sdk-input',{style:(_vm.inputStyle),attrs:{"placeholder":_vm.placeholder},on:{"blur":_vm.onBlur,"focus":_vm.onFocus,"input":_vm.onInput}}),_c('img',{attrs:{"src":_vm.cardImg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }